module.exports = __webpack_public_path__ + "static/media/profile-title-bg.b6ded0af.png";